import { useCallback } from 'react';
import useSWR, { useSWRConfig } from 'swr';
import api from '../api';
import { fetcher } from './swr';
import useToast from '../../hooks/useToast';
import Admin, { CreateAdminDTO, SchoolAdmin } from '../../models/Admin';
export default function useSchoolsAdmins() {
  const { addToast } = useToast();
  const { mutate } = useSWRConfig();
  const { data, error } = useSWR<SchoolAdmin[]>('/admins/school', fetcher, {
    dedupingInterval: 60 * 1000 * 60 * 5,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  const handleAddSchoolAdmin = useCallback(
    async (admin: CreateAdminDTO) => {
      try {
        await api.post('/admins/school', admin);
        addToast({
          type: 'success',
          title: 'Admin cadastrado com sucesso',
        });
      } catch (err) {
        addToast({
          type: 'error',
          title: 'Erro ao cadastrar novo admin',
        });
      } finally {
        mutate('/admins/school');
      }
    },
    [addToast, mutate],
  );

  const handleDeleteSchoolAdmin = async (adminId: string) => {
    try {
      await api.delete(`/admins/school/${adminId}`);
      addToast({
        type: 'success',
        title: 'Admin removido com sucesso',
      });
    } catch (error) {
      addToast({
        type: 'error',
        title: 'Erro ao remover Admin',
      });
    }
  };

  return {
    error,
    handleAddSchoolAdmin,
    handleDeleteSchoolAdmin,
    schoolAdmins: data || [],
    isLoading: !data && !error,
  };
}
